<template>
  <div class="download">
    <head-top :navActive="navActive"></head-top>
    <!-- 内容 start -->
    <div class="report-download">
      <div class="report-download-main">
        <div class="report-download-main-top">
          <div class="report-download-main-top-left">
            <div class="report-download-title">
              <i></i>
              <p>查询报告</p>
              <span>请输入订单编号或手机号，点击“查询报告”即可。</span>
            </div>
            <div class="report-download-input">
              <input type="text" placeholder="订单编号／手机号码" v-model="phone" @input="handleInput">
              <span class="report-download-input-btn" @click="getCheckingList">查询报告</span>
            </div>
          </div>
          <div class="report-download-code">
            <img src="../../static/img/ts-img/code.png" width="344">
            <img class="report-download-code-main" :src="code">
          </div>
        </div>
        <div class="report-download-line"></div>
        <div class="report-download-main-bottom">
          <div class="report-download-title">
            <i></i>
            <p>检测报告列表</p>
            <span>检测高峰期，检测时间较长，提交后请耐心等待。</span>
          </div>
          <table class="report-download-list">
            <thead>
            <tr>
              <td>论文标题</td>
              <td>论文作者</td>
              <td>产品名称</td>
              <td>检测时间</td>
              <td>检测状态</td>
              <td>操作</td>
              <td>删除报告</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item,index in checkingList" :key="item.id">
              <td>{{item.title}}</td>
              <td>{{item.author}}</td>
              <td>{{item.goods_name}}</td>
              <td>{{item.created_at}}</td>
              <td>{{['待付款', '检测中', '已完成','查重失败'][item.order_status]}}</td>
              <td>
                <p v-if="item.order_status == 2" @click="downCheckingList(item.id)">
                  <i><img src="../../static/img/ts-img/download-icon.png" width="13"></i>
                  <a class="download-txt" >下载报告</a>
                </p>
                <p v-if="item.order_status != 2">
<!--                  {{['待付款', '检测中', '已完成','查重失败'][item.order_status]}}-->
                <i><img src="../../static/img/graydown.png" width="13"></i>
                  <a class="download-txt-gray">下载报告</a>
                </p>
              </td>
              <td>
                <div v-if="item.order_status == 2 || item.order_status == 3">
                  <p class="cursor" v-if="item.is_delete == 1" @click="deleteCheckingList(item.id)">
                    <i><img src="../../static/img/ts-img/delete-icon.png" width="13"></i>
                    <span>删除</span>
                  </p>
                  <p class="no-cursor" v-if="item.is_delete == 0">
                    <i><img src="../../static/img/delete-icon-gray.png" width="13"></i>
                    <span>删除</span>
                  </p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="report-download-line"></div>
        <div class="download-notes">
          <div class="report-download-title">
            <i></i>
            <p>下载报告须知</p>
          </div>
          <div class="download-notes-txt">
            <p class="download-notes-txt-item">
              <span>检测失败：</span>
              在系统“检测状态”为 检测失败 时，请确认文章字符是否超出或者文章不符合要求并联系在线客服解决。
            </p>
            <p class="download-notes-txt-item">
              <span>合并订单：</span>
              如果是多篇文章使用的一个订单号检测的，只需要通过这个订单即可查询到所有的检测报告。
            </p>
            <p class="download-notes-txt-item">
              <span>删除报告：</span>
              报告检测完成后，可以自行删除检测报告，删除后不可恢复，请删除前确认。
            </p>
            <p class="download-notes-txt-item">
              <span>报告打开方式：</span>
              下载的报告为压缩包，需先用winrar软件解压。网页版报告用IE打开，pdf格式下载PDF阅读器。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 end -->
    <div class="query-failure" v-show="eject">
      <div class="query-failure-eject">
        <i class="zmr-close-eject" @click="closeFun()">
          <img src="../../static/img/ts-img/close-icon.png" alt="">
        </i>
        <div class="query-failure-count">
          <i>
            <img src="../../static/img/fail.png" alt="">
          </i>
          <div>
            <p>查询失败</p>
            <span>未找到该订单的检测记录 <br> 请核对后重新输入</span>
          </div>
        </div>
      </div>
    </div>
    <foot-bottom></foot-bottom>
  </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from '../assets/js/tool.js'
  import {
    $message,
    Message,
    MessageBox
  } from 'element-ui'

  export default {
    name: "ch-report-download",
    data () {
      return {
        navActive: 3,
        code:'',//二维码
        phone:'',//查重电话号码
        checkingList:[],//查重报告列表
        eject:false,//查询失败弹窗
        lock:false
      }
    },
    components: {
      headTop,
      footBottom,
    },
    mounted(){
      this.getVcode();
    },
    methods:{
      /*** 获取二维码*/
      getVcode:function(){
        let data = {};
        tool.postData('get_setting',data,(res)=>{
          this.code = res.data.data.wechat_qr_code
        })
      },
      handleInput(e){
        this.phone=e.target.value.replace(/[\W]/g,'');
      },
      /*** 获取查重报告*/
      getCheckingList:function () {
        if(this.lock==true){
          return
        }
        let data = {
          phone:this.phone
        };
        if(this.phone.length == 0){
          Message({
            showClose:true,
            message:'订单编号/手机号不能为空',
            type: 'error'
          });
          return this.lock=true;
        }
        tool.postData('get_checking_list',data,(res)=>{
          if(res.data.data.list.length <= 0)
          {
            this.eject=true;
            return this.lock=true;
          }
          this.checkingList = res.data.data.list
        })
      },
      /*** 删除查重报告*/
      deleteCheckingList:function (id) {
        if(this.lock==true){
          return
        }
          this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {
              id:	id
            };
            tool.postData('del_report',data,(res)=>{
              this.getCheckingList();
              this.eject=false;
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      closeFun(){
        this.eject = false
      },
    // 下载查重报告
      downCheckingList(id){
        let data = {
          id:id
        };
        tool.postData('add_report',data,(res)=>{
        });
        window.location.href='https://cnkijc.cn/api/download_report?id='+id;
        console.log(1111)
        this.getCheckingList();
      },
    },
    // 13856741650
    watch:{
      lock:function(o,v){
        console.log(o)
        if(o==true){
          var self=this
          setTimeout(()=>{
            self.lock=false
          },3000)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .download{
    width: 100%;
    height: 100%;
    background-color: #eff4ff;
    position: relative;
  }
  .report-download-title{
    width: 100%;
    height: 94px;
    display: flex;
    align-items: center;
    i{
      width: 10px;
      height: 10px;
      background-color: #3b6bda;
      margin-right: 10px;
    }
    p{
      @include font(25px,#333);
      margin-right: 20px;
      font-weight: bold;
    }
    span{
      @include font(20px,#666)
    }
  }
  .report-download-line{
    width: 100%;
    height: 10px;
    background-color: #eff4ff;
  }
  .report-download{
    width: 100%;
    background: url("../../static/img/nav.png") no-repeat top center;
    padding-top: 80px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .report-download-main{
      width: $box-width;
      margin: 0 auto;
      background-color: #fff;
      .report-download-main-top{
        width: 100%;
        height: 184px;
        background-color: #fff;
        @include flex;
        padding: 0 28px;
        box-sizing: border-box;
        .report-download-main-top-left{
          padding-bottom: 30px;
          .report-download-input{
            display: flex;
          }
          .report-download-input input{
            width: 489px;
            height: 53px;
            border: 1px solid #c4d2f4;
            padding-left: 14px;
            box-sizing: border-box;
            line-height: 53px;
            &::placeholder{
              @include font(16px,#999)
            }
          }
          .report-download-input-btn{
            width: 138px;
            line-height: 48px;
            background-color: #3b6bda;
            text-align: center;
            @include font(20px,#fff);
            margin-left: 20px;
            border-radius: 10px;
            cursor: pointer;
          }
          .report-download-input-btn:hover{
            background-color:#3a8ee6;
          }
        }
      }
      .report-download-main-bottom{
        width: 100%;
        padding: 0 28px 50px;
        box-sizing: border-box;
        .report-download-list{
          width: 100%;
          .cursor{
            cursor: pointer;
          }
          .no-cursor{
            cursor:text;
          }
          thead>tr>td{
            background-color: #3b6bda;
            text-align: center;
            line-height: 50px;
            @include font(20px,#fff)
          }
          tbody>tr>td{
            height: 79px;
            @include font(16px,#666);
            text-align: center;
            border-bottom: 1px solid #c4d2f4;
            .download-txt{
              color: #3b6bda;
              cursor: pointer;
              &:hover{
                text-decoration: underline;
              }
            }
            .download-txt-gray{
              color: #666;
            }
            &:first-child{
              width: 233px;
            }
            &:last-child{
              i{
                position: relative;
                top: -2px;
              }
            }
          }
        }
      }
      .download-notes{
        width: 100%;
        padding: 0 28px 70px;
        box-sizing: border-box;
        .download-notes-txt-item{
          @include font(16px,#666);
          line-height: 44px;
          span{
            color: #f14040;
          }
        }
      }
    }
  }
  .report-download-code{
    position: relative;

    .report-download-code-main{
      position: absolute;
      right: 0;
      top: 10px;
      width: 130px;
    }
  }
  .query-failure{
    width:100%;
    height:100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color:rgba(0,0,0,0.6);
    .query-failure-eject{
      width:492px;
      height:176px;
      background-color:#fff;
      position:fixed;
      top: 40%;
      left:35%;
      padding:20px;
      box-sizing: border-box;
      border-radius: 10px;
      .zmr-close-eject{
        float: right;
        display: block;
        width: 25px;
        height: 25px;
        overflow: hidden;
        cursor: pointer;
      }
      .query-failure-count{
        display:flex;
        justify-content:center;
        align-items: center;
        margin-top: 20px;
        i{
          display: block;
          width:95px;
          height: 104px;
          overflow: hidden;
          margin-right: 30px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        p{
          color: #ef6676;
          font-size: 30px;
          margin-bottom: 15px;
        }
        span{
          color: #999999;
          font-size: 16px;
          line-height: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ch-report-download.vue